<div class="h-full flex flex-column ">
    <div class="header-container flex justify-content-start align-items-center px-2 ">
        <img src="/assets/images/cloudbite-small.svg" />
    </div>
    
    <div class="menu-container overflow-y-auto flex flex-column w-full p-2 flex-grow-1 " > 
        <ng-container *ngFor="let main of menuList">
            <div class="menu-main-item p-2" (click)="clickMenu(main)" [ngClass]="{'active': navService.activeSideBar == main?.routerLink}" >
                <div class="flex column-gap-2 align-items-center">
                    <div class="menu-item-icon" [inlineSVG]="main?.importIcon" [setSVGAttributes]="{width: '17px', height: '17px'}"></div>
                    <span class="text-sm menu-item-title">{{ main?.title }}</span>
                </div>
                
                <i *ngIf="main?.subMenus" class="pi pi-chevron-down text-sm menu-icon" [class.open]="main?.expanded"></i>
            </div>
            <div [@subMenuShowHide]="main?.expanded ? 'in' : 'out'" > 
                <div class="sub-menu-item py-2 ps-4" *ngFor="let sub of (main?.subMenus ?? [])" (click)="clickSub(main, sub, origin)"  [ngClass]="{'active': navService.activeSideBar == sub.routerLink || sub == activePopParent  }" #origin="cdkOverlayOrigin" cdkOverlayOrigin>
                    <i class="pi pi-circle-fill" ></i>
                    <span class="text-sm menu-item-title">{{ sub?.title }}</span>
                </div>
                
            </div>
        </ng-container>
    </div>
    <div class="flex align-items-center justify-content-center ">
        <img src="/assets/images/powered-by.png" class="powered-by" />
    </div>
</div>


<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="activeOrigin"
  [cdkConnectedOverlayHasBackdrop]="true"
  (backdropClick)="displayPopMenu = false"
  backdropClass="transparent-backdrop"
  [cdkConnectedOverlayOpen]="displayPopMenu"
  [cdkConnectedOverlayPositions]="positions"
  [cdkConnectedOverlayPush]="true">
  <div class="pop-menu-container rounded flex flex-column shadow-sm border p-2">
    <div class="menu-item flex flex-row align-items-center column-gap-2 cursor-pointer py-2 px-2" [ngClass]="{'active': navService.selectedPage == popMenu.routerLink}" *ngFor="let popMenu of popMenuList" (click)="clickPop(popMenu)">
        <i class="pi pi-circle-fill" ></i>
        <span class="text-sm">{{ popMenu?.title }}</span>
    </div>
  </div>
</ng-template>